
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import { FooterComponent, FooterComputed, FooterData, FooterMethods } from '@owc-packages/Footer/src/Footer';
import SlotContainer from '@owc-packages/SlotContainer/src/SlotContainer.vue';
import OwcFooterMoveToTop from '@owc-packages/Footer/src/MoveToTop.vue';
import OwcFooterNewsletter from '@owc-packages/Footer/src/Newsletter.vue';
import OwcFooterSiteMap from '@owc-packages/Footer/src/SiteMap.vue';
import OwcFooterContactInfo from '@owc-packages/Footer/src/ContactInfo.vue';
import OwcFooterLowerFooter from '@owc-packages/Footer/src/LowerFooter.vue';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';
import { Props } from '../../_types/ComponentInitializeDispatcher';
import { setPageMode } from './Footer.config';
/**
 * `Footer` - Footer for OneWeb - Footer is the last module of the page. It contains links that help the user navigate through the website..
 */

export default (ComponentInitializeDispatcher as FooterComponent).extend<
  FooterData,
  FooterMethods,
  FooterComputed,
  Props
>({
  name: 'owc-footer',
  components: {
    OwcFooterMoveToTop,
    OwcFooterNewsletter,
    OwcFooterSiteMap,
    OwcFooterContactInfo,
    OwcFooterLowerFooter,
    SlotContainer,
    ValidationBoxWrapper,
  },
  computed: {
    moveToTop() {
      return this.componentData?.moveToTop;
    },
    newsletter() {
      return this.componentData?.newsletter;
    },
    siteMap() {
      return this.componentData?.siteMap;
    },
    contactInfo() {
      return this.componentData?.contactInfo;
    },
    socialSection() {
      return this.componentData?.socialSection;
    },
    legalSection() {
      return this.componentData?.legalSection;
    },
    moveToTopVisibility() {
      return !!this.moveToTop;
    },
    newsletterVisibility() {
      return !!this.newsletter;
    },
    siteMapVisibility() {
      return !!this.siteMap;
    },
    contactInfoVisibility() {
      return !!this.contactInfo;
    },
    socialSectionVisibility() {
      return !!this.socialSection;
    },
  },
  watch: {
    isEditMode: {
      handler(newValue: boolean, oldValue: boolean) {
        if (newValue !== oldValue) {
          setPageMode(newValue);
        }
      },
      immediate: true,
    },
  },
});
